// src/components/ThemeToggle.jsx
import React, { useEffect, useState } from 'react'
import { Moon, Sun } from 'lucide-react'
import { Button } from './ui/button'

const ThemeToggle = () => {
  const [theme, setTheme] = useState('dark')

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light'
    setTheme(savedTheme)
    document.documentElement.classList.toggle('dark', savedTheme === 'dark')
  }, [])

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light'
    setTheme(newTheme)
    localStorage.setItem('theme', newTheme)
    document.documentElement.classList.toggle('dark', newTheme === 'dark')
  }

  // return (
  //   // <Button
  //   //   variant="ghost"
  //   //   size="icon"
  //   //   onClick={toggleTheme}
  //   //   className="rounded-lg"
  //   // >
  //   //   {theme === 'light' ? (
  //   //     <Moon className="h-5 w-5" />
  //   //   ) : (
  //   //     <Sun className="h-5 w-5" />
  //   //   )}
  //   //   <span className="sr-only">Toggle theme</span>
  //   // </Button>
  // )
}

export default ThemeToggle